function RemoveSubscriptionOptionPDP(isDiscounted)
{
  //console.log("RemoveSubscriptionOption");

  var mainPriceContainer = document.querySelector('.product__info-wrapper .price.price--large');

  if(!isDiscounted && mainPriceContainer != null && mainPriceContainer.classList.contains("price--on-sale"))
  {
    mainPriceContainer.classList.remove("price--on-sale");
  }

  var targetBuyButton = document.querySelector('.product-form__buy-button input[name="selling_plan"]');
  targetBuyButton.value = "";

  document.querySelector('.subscriptionFrequencyValue').textContent = "One-Time Purchase";

  var subscriptionOptionsElement = document.querySelector("#subscriptionOptionsContainer");
  subscriptionOptionsElement.style.display = "none";

  UpdatePdpPricingMain();

  BelowFoldAddToCartUpdateProduct();
}

function HideSaleBadge()
{
  if(document.querySelector('.product-title-container .card-badgeV3.card-saleBadgeV3') == null)
    return;
  document.querySelector('.product-title-container .card-badgeV3.card-saleBadgeV3').style.display = "none"; 
}

function ShowSaleBadge()
{
  if(document.querySelector('.product-title-container .card-badgeV3.card-saleBadgeV3') == null)
    return;
  document.querySelector('.product-title-container .card-badgeV3.card-saleBadgeV3').style.display = "block"; 
}

function InitializeSubscriptionOptionPDP()
{

  console.log("InitializeSubscriptionOptionPDP");

  var subscriptionText = document.querySelector('.subscriptionActivateOption .subscription-discount-label').textContent;
  
  document.querySelector('.subscriptionFrequencyValue').textContent = subscriptionText;

  var mainPriceContainer = document.querySelector('.product__info-wrapper .price.price--large');

  if(mainPriceContainer != null && !mainPriceContainer.classList.contains("price--on-sale"))
  {
    mainPriceContainer.classList.add("price--on-sale");
  }
  
  UpdateSubscriptionOptionPDP();

  SubscriptionCheckIfShowSubDetails();

  UpdatePdpPricingMain();
}

function SubscriptionCheckIfShowSubDetails()
{

  if(document.querySelector(".subscriptionOption-container #optionSubscribe") == null)
    return;

  if (document.querySelector(".subscriptionOption-container #optionSubscribe").checked)
  {
    var subscriptionOptionsElement = document.querySelector("#subscriptionOptionsContainer");
    subscriptionOptionsElement.style.display = "block";
  }

}

function UpdateSubscriptionPricing(variantSku)
{
  //console.log("updateSubscriptionPricing variantSku = " + variantSku);


  var variantSkuHiddenId = "#SubscriptionWidgetPrice" + variantSku;
  var variantSkuHiddenPriceElement =  document.querySelector(variantSkuHiddenId);

  if(variantSkuHiddenPriceElement == null)
    return;
  
  var variantSkuHiddenPriceValue = variantSkuHiddenPriceElement.value;


  var variantSkuPriceDataSplit = variantSkuHiddenPriceValue.split('|');

  document.querySelector('.subscriptionActivationOptions input#optionNoSubscribe').setAttribute('sellingplanprice',variantSkuPriceDataSplit[0]);
  document.querySelector('.subscriptionActivationOptions input#optionSubscribe').setAttribute('sellingplanprice',variantSkuPriceDataSplit[1]);
  
  
  var variantSkuPriceBase = "$" + (variantSkuPriceDataSplit[0] / 100).toFixed(2);
  var variantSkuPriceDisc = "$" + (variantSkuPriceDataSplit[1] / 100).toFixed(2);

  document.querySelector('.subscriptionDeactivateOption .price-label').textContent = variantSkuPriceBase;
  document.querySelector('.subscriptionActivateOption .price-label').textContent = variantSkuPriceDisc;

  UpdatePdpPricingMain();
}

function UpdatePdpPricingMain()
{
  selectedOption = document.querySelector('input[name="optionSubscribe"]:checked');
  var sellingPlanPrice = selectedOption.getAttribute("sellingplanprice");

  //console.log('sellingPlanPrice = ' + sellingPlanPrice);

  var newUpdatedPricing = "$" + (sellingPlanPrice / 100).toFixed(2);

  var mainPriceElement = document.querySelector('.product__info-wrapper .price__container .price__regular .price-item--regular');
  var mainPriceSaleElement = document.querySelector('.product__info-wrapper .price__container .price-item--sale');
  var mainPriceRegularElement = document.querySelector('.product__info-wrapper .price__container .price__sale .price-item--regular').textContent.replace('$','');
  var mainPriceSalePercentElement = document.querySelector('.product__info-wrapper .price__container .price__sale .price-item-percent-off');

  
  var pricePercentDiscount = sellingPlanPrice / mainPriceRegularElement;
  var pricePercentDiscount = Math.round(100 - pricePercentDiscount);

  if(selectedOption.id == "optionSubscribe")
  {
    mainPriceSalePercentElement.textContent = "";
  }
  else
  {
    mainPriceSalePercentElement.textContent = pricePercentDiscount + "% Off";
  }
  
  mainPriceElement.textContent = newUpdatedPricing;
  mainPriceSaleElement.textContent = newUpdatedPricing;

  var variantRadioOptions = document.querySelectorAll('variant-radios input[type=radio]:checked+label');

  for (var i = 0; i < variantRadioOptions.length; i++) 
  {
    var nextVariantLabel = variantRadioOptions[i];
    if(nextVariantLabel.innerHTML.includes('$'))
    {
      //console.log('nextVariantLabel = ' + nextVariantLabel.innerHTML);
      var prefixText = variantRadioOptions[i].innerHTML.split('$')[0];
      var updatedText = prefixText + newUpdatedPricing;
      variantRadioOptions[i].innerHTML = updatedText;
    }
  }

  try
  {
    PricePerCountUpdate();
  }
  catch(error)
  {
    console.log('error UpdatePdpPricingMain' + error);
  }
}

function UpdateSubscriptionOptionPDP(selectedOption)
{

  if(selectedOption == null)
  {
    selectedOption = document.querySelector('#SubscriptionOptions');
  }
  
  var selectedValue = selectedOption.value;


  var targetBuyButton = document.querySelector('.product-form__buy-button input[name="selling_plan"]');


  if(targetBuyButton == null)
  {
    //console.log("Missing selling plan field");
    var buyButtonElement = document.querySelector('.product-form__buy-button form');
    var targetBuyButton = document.createElement("input");
    targetBuyButton.setAttribute("type", "hidden");
    targetBuyButton.setAttribute("name", "selling_plan");
    buyButtonElement.appendChild(targetBuyButton);
  }
  
  targetBuyButton.value = selectedValue;

  UpdatePdpPricingMain();

  BelowFoldAddToCartUpdateProduct();
  
  //console.log("UpdateSubscriptionOption  selectedValue = " + selectedValue);
}

function SubscribeClickOption(subscribeOption)
{
  //console.log("SubscribeClickOption");

  var targetInput = subscribeOption.querySelector('input');
  
  //console.log("targetInput = " + targetInput);

  targetInput.click();
}


function SubscribeWireUpEvents()
{
  subscribeOptions = document.querySelectorAll("#SubscriptionManager .subscriptionOption");


  //console.log('SubscribeWireUpEvents subscribeOptions count = ' + subscribeOptions.length);
  
  for (var i = 0; i < subscribeOptions.length; i++) 
  {
    var nextSubscribeOption = subscribeOptions[i];
    nextSubscribeOption.addEventListener("click",  function(){ SubscribeClickOption(this); }, false);
  }

  

  var checkedSubscriptionOptions = document.querySelectorAll('#SubscriptionManager .subscriptionOption input[type="radio"]');
  for (var i = 0; i < checkedSubscriptionOptions.length; i++) 
  {
    var nextSubscribeOption = checkedSubscriptionOptions[i];
    //console.log("nextSubscribeOption checked value = " + nextSubscribeOption.checked);
  }

  SubscriptionCheckIfShowSubDetails();
}



function OpenDeliveryOptions()
{
  //console.log("OpenDeliveryOptions");
  var dropdown = document.getElementById('SubscriptionOptions');
  dropdown.showPicker();
}

addEventListener("load", (event) => {
   SubscribeWireUpEvents();
});